import { render, staticRenderFns } from "./AdminLinkDataEdit.vue?vue&type=template&id=591d1d53&scoped=true&"
import script from "./AdminLinkDataEdit.vue?vue&type=script&lang=js&"
export * from "./AdminLinkDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminLinkDataEdit.vue?vue&type=style&index=0&id=591d1d53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d1d53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591d1d53')) {
      api.createRecord('591d1d53', component.options)
    } else {
      api.reload('591d1d53', component.options)
    }
    module.hot.accept("./AdminLinkDataEdit.vue?vue&type=template&id=591d1d53&scoped=true&", function () {
      api.rerender('591d1d53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminLinkDataEdit.vue"
export default component.exports